import React, {Component} from 'react';
import Config from '../../config';
import { Grid, Card, CircularProgress } from '@mui/material';
import {withRouter} from 'react-router-dom';
import axios from 'axios';
import FileSaver from 'filesaver.js-npm';
import Helpers from "../../helpers";

// location comes from react-router v5's withRouter. Typed via the `history`
// package, mirroring attachments_v2.tsx.
interface AttachmentStorageProps {
    location: import('history').Location;
}

interface AttachmentStorageState {
    completed: number;
    determinate: boolean;
}

class AttachmentStorage extends Component<AttachmentStorageProps, AttachmentStorageState> {
    state: AttachmentStorageState = {completed: 0, determinate: false};
    filePath: string;
    fileName: string;
    missing: boolean;
    constructor(props: AttachmentStorageProps){
        super(props);
        // Route is /storage/<path/to/file>; guard bare /storage (no file path) so we
        // render a message instead of crashing on `undefined.split('/')`.
        this.filePath = this.props.location.pathname.split('/storage/')[1] || '';
        const sp = this.filePath.split('/');
        this.fileName = sp[sp.length - 1];
        this.missing = this.filePath === '';
    }
    async componentDidMount(){
        if(this.missing){ return; }
        var res = await axios({
          url: Config.api + "/api/v1/attachments/" + this.filePath,
          method: 'GET',
          responseType: 'blob',
          onDownloadProgress: async function (this: AttachmentStorage, progressEvent: any) {
            if(progressEvent.total){
                var progress = 100 * (progressEvent.loaded / progressEvent.total);
                await this.setState({determinate: true, completed: progress});
            }
        }.bind(this)});
        this.setState({determinate: true, completed: 100});
        var blob = new Blob([res.data], { type: res.headers["content-type"] || "application/octet-stream" });
        (FileSaver as any).saveAs(blob, this.fileName);
        if(new Helpers().queryString()["close"]){
            window.setTimeout(() => window.close(), 75);
        }
    }
    render(){
        if(this.missing){
            return (<Grid container spacing={2}>
                <Grid size={{ md: 12 }}>
                    <Card>
                    <div style={{padding: '1em'}}>No file specified — open a file link from your attachments to download it.</div>
                    </Card>
                </Grid>
            </Grid>);
        }
        return (<Grid container spacing={2}>
            <Grid size={{ md: 12 }}>
                <Card>
                <div style={{padding: '1em'}}>Downloading file</div>
                <div style={{position: 'relative'}}>
                    <CircularProgress variant={this.state.determinate ? 'determinate' : 'indeterminate'} value={this.state.completed} size='8em'/>
                    <div style={{position: 'absolute', top: 0, height: '100%', width: '100%', lineHeight: '5.5em', fontSize: '1.5em'}}>{this.state.completed.toFixed(0)}%</div>
                </div>
                <div style={{padding: '1em'}}>{this.fileName}</div>
                </Card>
            </Grid>
        </Grid>);
    }
}

// AttachmentStorage only consumes `location`; cast at the withRouter boundary
// so the HOC's RouteComponentProps constraint is satisfied without widening the
// component's own props to the full router surface.
export default withRouter(AttachmentStorage as any);
